import script from "./TrafficOwner.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficOwner.vue?vue&type=script&setup=true&lang=js"

import "./TrafficOwner.vue?vue&type=style&index=0&id=e6e1981a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6e1981a"]])

export default __exports__